var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.317,
    height: 21.267,
    viewBox: "0 0 22.317 21.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(-6003.536 -6681.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M6015.079,6681.335l3.117,6.315a.428.428,0,0,0,.322.234l6.968,1.012a.429.429,0,0,1,.238.731l-5.042,4.915a.433.433,0,0,0-.124.38l1.191,6.939a.429.429,0,0,1-.622.452l-6.232-3.276a.427.427,0,0,0-.4,0l-6.233,3.276a.429.429,0,0,1-.622-.452l1.191-6.939a.43.43,0,0,0-.123-.38l-5.043-4.915a.429.429,0,0,1,.238-.731l6.968-1.012a.429.429,0,0,0,.323-.234l3.116-6.315A.429.429,0,0,1,6015.079,6681.335Z",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/iconStar.c685212aaa72e12b66397c0af8b400ac.svg";
export { ForwardRef as ReactComponent };